const SCHEMA: string = process.env.REACT_APP_MAESTRO_SEDE_SCHEMA || '';
const ENTITY: string = process.env.REACT_APP_MAESTRO_SEDE_ENTITY || '';
const CHANGE_PASSWORD: string = '/SigoPwa/Usuarios/ChangePassword';

export const AdapterConfigure = {
    SCHEMA,
    ENTITY,
    CHANGE_PASSWORD,
};